import './index.css';

interface Props {
  label: string;
}
const IndicatorLabel = (props: Props) => {
  return (
    <div className="indicator-label-container">
      <span className="indicator-label-text">{props.label}</span>
    </div>
  );
};

export default IndicatorLabel;
